<template>
  <section>
    <div class="tip" style="margin:25px 0 0 40px">* 提交资料</div>
    <ul class="project-info-list">
      <li>
        <label>所在单位/部门：</label>
        <div class="info-item">{{ form.creator.department }}</div>
      </li>
      <li>
        <label>考勤未签到：</label>
        <div class="info-item">
          <user-info :userData='form.creator'></user-info>
        </div>
      </li>

      <!-- <li>
        <label>请假类型：</label>
        <div class="info-item">{{ form.type }}</div>
      </li>

      <li v-if="form.type=='年休假'" style="font-weight:bold;color:#409EFF;">
        <label style="font-weight:bold;color:#409EFF;">已请年休假：</label>
        <div class="info-item">{{ form.leaveDays }} 天</div>
      </li>
      <li class="block">
        <label>请假时间：</label>
        <div class="info-item">{{ getSTime(form.startTime)+" 至 "+getSTime(form.endTime)+"    共"+form.totalTime+"天" }}
        </div>
      </li>
      <li class="block intro-box">
        <label>请假原因：</label>
        <div class="info-item">{{ form.content }}</div>
      </li> -->
    </ul>
    <div class="kq-item" style="margin:0 56px" v-for="item in form.items">
      <li>
        <label style="float:left;">未签到时间：</label>
        <div class="info-item">{{ item.time }}</div>
      </li>
      <li>
        <label style="float:left;">未签到节点：</label>
        <el-tag v-if="item.swqd" size="mini" type="danger">上午签到</el-tag>
        <el-tag v-if="item.swqt" size="mini" type="danger">上午签退</el-tag>
        <el-tag v-if="item.xwqd" size="mini" type="danger">下午签到</el-tag>
        <el-tag v-if="item.xwqt" size="mini" type="danger">下午签退</el-tag>
      </li>
      <li class="block intro-box">
        <label style="float:left;">未签原因：</label>
        <div class="info-item">{{ item.reason }}</div>
      </li>
    </div>
  </section>
</template>
<script>
  import UserInfo from '@/components/UserInfo'
  export default {
    props: ['form', 'userData'],
    components: {
      UserInfo,
    },
    data() {
      return {}
    },
    mounted() {},
    methods: {
      // 时间截取
      // getSTime(time) {
      //   let _t = time.split(":")
      //   return _t[0] + ":" + _t[1]
      // },
    }
  }

</script>



// WEBPACK FOOTER //
// src/page/user/projectinfo/kqApply.vue